// Route d'auto-login OIDC (/auth/bpm) : point d'entrée du bouton « Pool » côté BPM Sports.
// Lance le flux OIDC automatiquement, sans clic sur « Se connecter avec le partenaire ».

import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { login } from '../../services/oidc/login';
import { useUserStore } from '../../lib/userStore';
import { useLeagueStore } from '../../lib/leagueStore';
import { getEmbedAwarePath } from '../../lib/embedStore';

export function OidcAutoLogin() {
  const navigate = useNavigate();
  const clearUser = useUserStore((state) => state.clearUser);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  // Guard contre la double exécution du useEffect (StrictMode) : login() redirige le navigateur
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    // Vider la session cachée pour garantir que c'est toujours le compte BPM qui s'authentifie
    clearUser();
    useLeagueStore.getState().setSelectedLeague(null);

    login().catch((error) => {
      console.error('OIDC auto-login error:', error);
      const message =
        error instanceof Error ? error.message : 'Erreur lors de la connexion avec le partenaire';
      setErrorMessage(message);
      toast.error(message);
      // Repli vers /auth pour éviter toute boucle de redirection
      navigate(getEmbedAwarePath('/auth'), { replace: true });
    });
  }, [clearUser, navigate]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 gap-3">
      {errorMessage ? (
        <p className="text-danger">{errorMessage}</p>
      ) : (
        <>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Connexion en cours…</span>
          </div>
          <p className="text-muted">Connexion en cours…</p>
        </>
      )}
    </div>
  );
}
